import styled from 'styled-components';
import ButtonProps from '../../../../shared/types/props/button';
import Screen from '../../../../shared/utils/screen';

const KeyEmpty = styled.div<ButtonProps>`
  float: left;
  height: ${39 * Screen.widthRatio}px;
  margin-bottom: ${10 * Screen.widthRatio}px;
  margin-right: ${22 * Screen.widthRatio}px;
  position: relative;
  text-align: center;
  width: ${26 * Screen.widthRatio}px;
`;

export default KeyEmpty;
